module.exports = __webpack_public_path__ + "static/media/slide3_article2_small.447b4662.jpg";